import { TimeRange } from '@mi-front/core';

/**
 * Maps a viewport X coordinate to a timestamp inside `range`, using the
 * element's bounding box. Clamped so clicks outside the edges stay in-range.
 */
export function clientXToTs(
  clientX: number,
  rect: Pick<DOMRect, 'left' | 'width'>,
  range: TimeRange<number>,
): number {
  if (rect.width <= 0) {
    return range.from;
  }

  const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
  return Math.round(range.from + ratio * (range.to - range.from));
}
